__webpack_require__.p = "https://static.age.awaze.com/postbook-auth-mfe/9516d65d3c587efcd9ba8e3a5e6eec66ccf94e86/_next/";